import { render, staticRenderFns } from "./UsageDashboard.vue?vue&type=template&id=0fbdb554&scoped=true&"
import script from "./UsageDashboard.vue?vue&type=script&lang=js&"
export * from "./UsageDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UsageDashboard.vue?vue&type=style&index=0&id=0fbdb554&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbdb554",
  null
  
)

export default component.exports